import { render, staticRenderFns } from "./Contest.vue?vue&type=template&id=9e96e6ee&scoped=true"
import script from "./Contest.vue?vue&type=script&lang=js"
export * from "./Contest.vue?vue&type=script&lang=js"
import style0 from "./Contest.vue?vue&type=style&index=0&id=9e96e6ee&prod&lang=scss&scoped=true"
import style1 from "./Contest.vue?vue&type=style&index=1&id=9e96e6ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e96e6ee",
  null
  
)

export default component.exports